export enum EApprovalDecision {
  APPROVED = "APPROVED",
  REJECTED = "REJECTED"
}
